module.exports = __webpack_public_path__ + "img/ico-location.bbce32ad.svg";